module.exports = __webpack_public_path__ + "static/media/gstlogo.0f8fa4cd.png";